import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../../../configs/colors';

export const SortContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '0 16px 8px',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const SortLabel = styled(Box)({
  fontSize: '0.75rem',
  fontWeight: 700,
  color: COLORS.DarkGray,
  whiteSpace: 'nowrap',
  flexShrink: 0,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
});

interface SortPillProps {
  active?: boolean;
}

export const SortPill = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<SortPillProps>(({ active }) => ({
  padding: '8px 14px',
  borderRadius: '20px',
  border: active ? 'none' : `1.5px solid ${COLORS.CardBorder}`,
  background: active
    ? `linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%)`
    : COLORS.CardBackground,
  color: active ? COLORS.White : COLORS.DarkGray,
  fontWeight: 600,
  fontSize: '0.75rem',
  cursor: 'pointer',
  transition: 'all 0.2s',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  fontFamily: 'inherit',
  minHeight: '44px',
  boxShadow: active ? '0 2px 8px rgba(23, 104, 120, 0.25)' : 'none',
  '&:active': {
    transform: 'scale(0.95)',
  },
  '&:focus-visible': {
    outline: `2px solid ${COLORS.NavyBlue}`,
    outlineOffset: '2px',
  },
}));
